// useTranslations.ts
import i18n from './i18n'; // Your i18n setup
import { Translations } from './translations.d'; // Import the interface

export const useTranslations = (): Translations => {
  const translations = i18n.getResourceBundle(i18n.language, 'translation') as Translations;
  return translations;
};
